<template>
  <div>
    <div class="header" :style="{
      borderTopColor: visualSettings.channelHeaderBackgroundColor,
      borderTopWidth: visualSettings.channelHeaderBorderWidth,
      borderBottomColor: visualSettings.channelHeaderBorderColor, 
      borderBottomWidth: visualSettings.channelHeaderBorderWidth,
      backgroundColor: visualSettings.channelHeaderBackgroundColor
    }">
      <div class="v-align">
        <div class="close">
          <button @click="back()" aria-label="Close">
            <fa-icon 
              :icon="['fas', 'angle-left']" 
              size="2x"
            />
          </button>
        </div>
        <div class="label" :style="{ color: visualSettings.channelHeaderLabelColor }">Thread</div>
      </div>
    </div>

    <div class="content" ref="vsl">
      <Message 
        :text="activeMessage.text"
        :pinned="activeMessage.pinned"
        :attachment="activeMessage.attachment"
        :time="activeMessage.id"
        :sender="activeMessage.sender"
        :channelId="activeMessage.channelId"
        :reply="true"
      />

      <div class="divider">
        <div class="wrap" :style="{ backgroundColor: visualSettings.bodyBackgroundColor }">
          <span>{{`${sortedReplies.length} ${sortedReplies.length === 1 ? 'Reply' : 'Replies'}`}}</span>
        </div>
        <div class="line"></div>
      </div>

      <div v-for="(reply, index) in sortedReplies" :key="index">
        <Message 
          :text="reply.value"
          :time="reply.actionId"
          :sender="userById(reply.userUuid)"
          :channelId="activeMessage.channelId"
          :disabled="true"
          :showTime="true"
        />
      </div>

      <div class="gap"></div>
    </div>

    <div class="communicator">
      <div class="inner" :style="{ backgroundColor: visualSettings.bodyBackgroundColor }">
        <Communicator :reply="true" />
      </div>
      <div class="spacer"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

import Message from '@/components/Message';
import Communicator from '@/components/Communicator';

export default {
  name: 'MessageDetail',
  components: {
    Message,
    Communicator
  },
  computed: {
    ...mapState([
      'activeChannel',
      'activeMessageId'
    ]),
    ...mapGetters([
      'visualSettings',
      'userById',
      'messageById',
      'messageActionsById'
    ]),
    activeMessage() {
      return this.messageById({
        channelId: this.activeChannel.id,
        messageId: this.activeMessageId
      });
    },
    sortedReplies() {
      const actionIds = [];
      const actions = [];
      this.messageActionsById({
        channelId: this.activeChannel.id,
        messageId: this.activeMessageId
      }).forEach((action) => {
        if (!actionIds.includes(action.actionId)) {
          actions.push(action);
          actionIds.push(action.actionId);
        }
      });
      return actions.filter((action) => (action.type === 'reply')).map((action) => {
        return {
          ...action,
          value: action.value.substring(action.value.indexOf(':')+1)
        }
      });
    }
  },
  watch: {
    activeMessageId(newVal) {
      newVal && this.scrollToBottom();
    }
  },
  methods: {
    ...mapMutations([
      'setDrawerOpen'
    ]),
    back() {
      this.setDrawerOpen(false);
    },
    scrollToBottom() {
      const container = this.$refs.vsl;
      container.scrollTop = container.scrollHeight;
    }
  },
  mounted() { 
    if (this.$refs.vsl) {
      console.log('mounted');
      this.scrollToBottom();
    }
  },
  destroyed() { },
  updated() {
    if (this.$refs.vsl) {
      console.log('updated');
      this.scrollToBottom();
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 54px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 32px 0 12px;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #eaebef;

  @media only screen and (max-width: 768px) {
    padding-right: 12px;
  }

  > .v-align {
    display: table;
    width: 100%;
    height: 100%;
  }

  h5 {
    font-size: 13.6px;
    margin: 0;
  }

  .close {
    display: table-cell;
    vertical-align: middle;
    padding: 0 10px 0 0;
    width: 1px;

    button {  
      border: 0;
      width: 33px;
      height: 33px;
      background: #fff;
      border-radius: 8px;
      cursor: pointer;
      background: rgba(234, 235, 239, 0.5);

      &:hover {
        background: #eaebef;
      }
    }
  }

  .label {
    display: table-cell;
    vertical-align: middle;
    width: 99%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    font-size: 13.6px;
    font-weight: bold;
    margin: 0;
  }
}

.content {
  position: absolute;
  top: 54px;
  left: 0;
  right: 0;
  bottom: 60px;
  padding: 0 20px;
  overflow: hidden;
  overflow-y: auto;

  @media only screen and (max-width: 768px) {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.communicator {
  position: absolute;
  display: flex;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 0 0 0;
  height: 60px;
  z-index: 1;

  > .inner {
    flex: 1;
    padding: 0 20px 0 0;
    width: 100%;
    background: #fff;

    @media only screen and (max-width: 768px) {
      padding-right: 16px;
    }
  }

  .spacer {
    flex: 0 0 auto;
    opacity: 0;
    font-size: 0;
    height: 30px;
    scrollbar-color: rgba(0,0,0,0) rgba(0,0,0,0);
    position: relative;
    overflow-y: scroll;

    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
}

.divider {
  position: relative;
  text-align: center;
  margin: -15px 0;

  .wrap {
    position: relative;
    display: inline-block;
    border-radius: 25.5px;
    background: #fff;
    padding: 9px 10px;
    z-index: 1;
  }

  span {
    font-size: 13.6px;
    line-height: 1.3;
    display: inline-block;
    height: 33px;
    box-sizing: border-box;
    color: rgba(0,0,0,0.3);
    border: 1px solid rgba(0,0,0,0.1);
    padding: 6px 14px;
    border-radius: 16.5px;
  }

  .line {
    position: absolute; 
    width: 100%;
    top: 50%;
    height: 1px;
    background: rgba(0,0,0,0.1);
  }
}

.gap {
  height: 5px;
} 
</style>
